import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { GoalDetails } from 'fragments';
import { SkillCard } from 'components';
import { Images, renderGoalTypes, useModal } from 'utils';
import { ManualTargetRow } from './manualTargetRow';

/**
 * Goal accordion list of the manual data entry screen. Same markup and classes as the live
 * `SessionGoalListTargets`, but renders `ManualTargetRow` and reads the client from props — there
 * is no live `sessionById` behind it. Expand state is owned by `ManualSession` (Collapse / Expand all).
 */
export const ManualGoalList = ({ goals, clientId, collapsedGoalIds, onToggleGoal, entries, entryError, onTargetChange }) => {
    const { open } = useModal();
    const notPinnedGoals = goals.filter((i) => !i?.pinned);

    return (
        <div style={{ padding: '8px 16px' }}>
            {notPinnedGoals.map((item) => {
                const goal = item?.goal;
                const goalId = goal?.id;
                const isOpen = !collapsedGoalIds?.has(goalId);
                return (
                    <div key={goalId} className="session-list-card-wrapper">
                        <Accordion expanded={isOpen} onChange={() => onToggleGoal?.(goalId)}>
                            <AccordionSummary style={{ background: '#FFF' }}>
                                <div className="space-between" style={{ gap: 12, width: '100%' }}>
                                    <div className="flex-align-center" style={{ gap: 12 }}>
                                        <button
                                            className="goal-link-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                open(<GoalDetails goalId={goalId} requestParams={{ clientId }} clientId={clientId} viewOnly />);
                                            }}
                                        >
                                            {goal?.name}
                                        </button>

                                        <SkillCard type={goal?.type} />
                                    </div>

                                    <div className="flex-align-center" style={{ gap: 12 }}>
                                        <div className="correct-goal-box">{renderGoalTypes(goal?.dataType)}</div>
                                        <button
                                            style={{ width: 36, height: 36 }}
                                            className="session-gray-action-btn-box"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onToggleGoal?.(goalId);
                                            }}
                                        >
                                            <img
                                                style={{
                                                    transition: 'transform 0.3s ease',
                                                    transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                                }}
                                                src={Images.dropdownArrow}
                                                alt="toggle"
                                            />
                                        </button>
                                    </div>
                                </div>
                            </AccordionSummary>

                            <AccordionDetails>
                                {goal?.targets?.map((target, j) => (
                                    <div key={target?.id}>
                                        <ManualTargetRow
                                            goal={goal}
                                            target={target}
                                            trials={entries[target?.id] || []}
                                            onChange={(trials) => onTargetChange(target?.id, trials)}
                                            errorTrial={entryError?.targetId === target?.id ? entryError.trialIndex : null}
                                            isLast={j === goal.targets.length - 1}
                                        />
                                    </div>
                                ))}
                            </AccordionDetails>
                        </Accordion>
                    </div>
                );
            })}
        </div>
    );
};
